import { render } from "./editarFundamental2.vue?vue&type=template&id=17595abd&scoped=true"
import script from "./editarFundamental2.vue?vue&type=script&lang=js"
export * from "./editarFundamental2.vue?vue&type=script&lang=js"

import "./editarFundamental2.vue?vue&type=style&index=0&id=17595abd&lang=scss&scoped=true"
import "./editarFundamental2.vue?vue&type=style&index=1&id=17595abd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17595abd"]])

export default __exports__